import { render, staticRenderFns } from "./moneyPay.vue?vue&type=template&id=320bea1f&scoped=true"
import script from "./moneyPay.vue?vue&type=script&lang=js"
export * from "./moneyPay.vue?vue&type=script&lang=js"
import style0 from "./moneyPay.vue?vue&type=style&index=0&id=320bea1f&prod&lang=scss&scoped=true"
import style1 from "./moneyPay.vue?vue&type=style&index=1&id=320bea1f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320bea1f",
  null
  
)

export default component.exports